import React from "react";
import FJLocalStore from "../../../../store/FJLocalStore";
import styles from './FJNoResults.module.less';
import InlineSVG from "react-inlinesvg";
import EmptyIcon from "../../../../icon/search_empty.svg";
import classNames from 'classnames';

function FJNoResults(props) {
	return (
		<div className={classNames(styles.no_result, {[styles.active]: props.active})}>
			<div className={styles.no_result_icon}>
				<InlineSVG src={EmptyIcon}/>
			</div>
			<span className={styles.search_empty_text}>
				{FJLocalStore._('stock-search-empty').replace('xxx', props.keywords)}
			</span>
		</div>
	)
}


export default FJNoResults;